/* eslint-disable */
import firebase from 'firebase';
import store from '../store/index';
import * as webUtils from '../utils/WebUtils'
import * as commonConstants from '../config/commonConstants'

const config = {
    apiKey: "AIzaSyB-TdNjuM3FA9bg0P8RsCC9EQ-YgZWDnIQ",
    authDomain: "rndinsider-49093.firebaseapp.com",
    databaseURL: "https://rndinsider-49093.firebaseio.com",
    projectId: "rndinsider-49093",
    storageBucket: "rndinsider-49093.appspot.com",
    messagingSenderId: "534187481542"
};

export function initializeMyApp(){
  firebase.initializeApp(config);

  firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
      // User is signed in.
      var displayName = user.displayName;
      var email = user.email;
      var emailVerified = user.emailVerified;
      var photoURL = user.photoURL;
      var isAnonymous = user.isAnonymous;
      var uid = user.uid;
     
      var providerData = user.providerData;
       store.dispatch('userLoggedIn',user)
       firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
        // Send token to your backend via HTTPS
        console.log("Sending to backend: " + idToken)
        replaceWithAccessToken(idToken)
      }).catch(function(error) {
        // Handle error
      });
    } else {
      alert("CYA");
    }
  });
}

export function replaceWithAccessToken(token){
  console.log("replacing with access token: " + token)
  fetch("http://localhost:8081/auth2",{
    method: "POST",
    headers: {"Authorization": ""  + token}
  }).then(function(myresponse){
      myresponse.json().then(
        function(data){
          webUtils.placeInCookie(data.token);
          let accessToken = webUtils.getCookie(commonConstants.COOKIE_NAME_RNDINSIDER_BEARERTOKEN);
          //alert(accessToken)
          store.dispatch('ready')
        }
    ,(reason)=>alert("Rejected: " + reason))
  })
}


